const BRANDING_GATEWAY_BASE_URL =
  'https://bx-branding-gateway.cloud.seek.com.au';

export const getSerpLogoFromBrandId = (brandId?: string) =>
  Boolean(brandId)
    ? `${BRANDING_GATEWAY_BASE_URL}/${brandId}/serpLogo`
    : undefined;
